<template>
  <kst-form v-if="invoiceId" no-bezel class="pb-5">
    <template #top-right>
      <kst-button action-mode full-label
        class="is-primary"
        :module="Model.Module"
        :moduleType="Model.ModuleType.New"
        :urlParams="urlParams"
      />
    </template>
  </kst-form>
</template>

<script>
import Model from "../DeliveryModel.js";

export default {
  props: {
    invoiceId: Number
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.InvoiceID]: this.invoiceId
      });
    }
  },
}
</script>